<template>
    <div>
        <div v-if="showWidget == 1">
            <div class="part">
                <p>
                    {{
                        $t(
                            "Get the cheapest shipping rates and best quality for all your logistics services."
                        )
                    }}
                </p>
                <router-link to="/send-shipment" class="button is-primary">
                    {{ $t("Send new shipment") }}
                </router-link>
            </div>
            <div class="part-2">
                <p>
                    {{ $t("You can also get a quick quote within seconds!") }}
                </p>
                <button class="button" @click="showWidget = 2">
                    {{ $t("Get estimated rate") }}
                </button>
            </div>
        </div>
        <div v-else>
            <div class="calc">
                <p :class="{ active: showWidget == 2 }" @click="showWidget = 2">
                    {{ $t("Domestic destinations") }}
                </p>
                <p :class="{ active: showWidget == 3 }" @click="showWidget = 3">
                    {{ $t("International destinations") }}
                </p>
            </div>
            <div>
                <widget-domestic v-if="showWidget == 2" />
                <widget-international v-if="showWidget == 3" />
            </div>
        </div>
    </div>
</template>

<script>
import WidgetDomestic from "@/components/Homepage/Domestic.vue";
import WidgetInternational from "@/components/Homepage/International.vue";
export default {
    data() {
        return {
            showWidget: 1,
        };
    },
    components: {
        WidgetDomestic,
        WidgetInternational,
    },
};
</script>

<style lang="scss" scoped>
.calc {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    font-size: 12px;

    p {
        margin: 0 10px;
        color: #777;
        font-weight: bold;
        cursor: pointer;

        &.active {
            color: #000;
        }
    }
}

.part-2 {
    width: 100%;
    height: 100%;
    text-align: left;

    &:lang(ar) {
        text-align: right;
    }

    p {
        width: 85%;
        font-size: 1.2rem;
        line-height: 1.2;
        margin-bottom: 20px;
    }

    .button {
        border-radius: 2px !important;
        padding: 10px 35px;
        margin-bottom: 20px;
        background: #000;
        color: white;
    }
}

.part {
    width: 100%;
    height: 100%;
    text-align: left;

    &:lang(ar) {
        text-align: right;
    }

    margin-bottom: 50px;

    p {
        width: 90%;
        font-weight: bold;
        font-size: 1.8rem;
        line-height: 1.2;
        margin-bottom: 20px;
        margin-top: 20px;
    }

    .button {
        border-radius: 2px !important;
        padding: 10px 35px;
        margin-bottom: 20px;
        width: 200px;
    }
}
</style>
